import type { PublicBrand } from "./api";

/** Puts the brand on the document: CSS variables, the font from Google Fonts, the title and the theme colour. */
export function applyBrand(brand: PublicBrand | null) {
  const root = document.documentElement;
  const theme = brand?.theme;
  root.style.setProperty("--primary", theme?.primary ?? "#1F2937");
  root.style.setProperty("--primary-text", theme?.primaryText ?? "#FFFFFF");
  root.style.setProperty("--accent", theme?.accent ?? "#1F2937");
  root.style.setProperty("--surface", theme?.surface ?? "#F9FAFB");
  const font = theme?.font ?? "Lexend";
  root.style.setProperty("--font", `"${font}", system-ui, -apple-system, "Segoe UI", sans-serif`);
  loadFont(font);
  document.title = brand ? `${brand.name} · My trips` : "My trips";
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta && theme) meta.content = theme.primary;
}

const loaded = new Set<string>();

function loadFont(family: string) {
  if (loaded.has(family)) return;
  loaded.add(family);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, "+")}:wght@300;400;500;600;700&display=swap`;
  document.head.appendChild(link);
}
